var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationArrowRegular = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M461.9 0c-5.7 0-11.6 1.1-17.4 3.5L28.7 195.4c-48 22.4-32 92.8 19.2 92.8h175.9v175.9c0 30 24.2 47.9 48.7 47.9 17.3 0 34.8-8.9 44-28.7L508.4 67.5C522.1 34.9 494.1 0 461.9 0M271.8 464.1V240.2h-48l-175.5.7c-.3-.4-.5-1.4.5-1.9L462.1 48.3c.6.4 1.3 1.1 1.7 1.7z"
})));
export { SvgLocationArrowRegular as ReactComponent };
export default __webpack_public_path__ + "static/media/location-arrow-regular.3f8fe6d7.svg";